import Axios from "axios";

const baseUrl =
  process.env.REACT_APP_API_URL ||
  "https://api.staging.s1.zabanshenas.com/api/v1";

const axios = Axios.create({ baseURL: baseUrl });
// axios.interceptors.request.use(function () {
//   /*...*/
// });
let headers = {
  "api-key": process.env.REACT_APP_API_KEY || "testapikey",
  "app-version": "1.0.0",
  "app-market": "main",
  "app-referrer": "main",
  "app-platform": "sso",
};
export const setAxiosDefaults = (token) => {
  axios.defaults.headers.common = headers;
  axios.defaults.headers.common["authorization"] = `${token}`;
};

export const getViewMessage = (conversation_id) =>
  axios.get(`viewMessage`, { params: { conversation_id } });

export const postConversationMessage = ({ message, conversation_id }) => {
  const formData = new FormData();
  formData.append("message", message);
  formData.append("conversation_id", conversation_id);
  return axios.post(`postConversationMessage`, formData);
};

export const setConversationLike = (conversation_id, like) =>
  axios.post(`setConversationLike`, { conversation_id, like });

export const unsubscribe = ({ token, conversation_id }) =>
  axios.get(`unsubscribe`, {
    params: { token, resubscribe: "false", conversation_id },
  });

export const resubscribe = ({ token, conversation_id }) =>
  axios.get(`unsubscribe`, {
    params: { token, resubscribe: "true", conversation_id },
  });
